<template>
  <div class="table_content">
    <div class="customer_list_table">
      <el-table
        ref="table"
        size="small"
        header-cell-class-name="brand-table-header-cell"
        cell-class-name="brand-table-cell"
        v-loading="loading"
        :data="tableData"
        height="100%"
      >
        <el-table-column type="index" label="序号"></el-table-column>
        <!-- <el-table-column
          prop="name"
          label="产品名称"
          show-overflow-tooltip
        ></el-table-column> -->
        <el-table-column prop="version" label="版本号"></el-table-column>
        <el-table-column
          prop="releaseTime"
          label="发布时间"
          :formatter="formaterTime"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          :formatter="formaterTime"
        ></el-table-column>
        <el-table-column prop="content" label="更新内容">
          <template slot-scope="scope">
            <div style="white-space: pre-wrap">{{ scope.row.content }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="公开状态" :width="80">
          <template slot-scope="scope">
            <el-popconfirm
              confirmButtonText="确定"
              cancelButtonText="取消"
              :hideIcon="true"
              title="是否改变该日志公开状态吗"
              @cancel="handleCancel(scope.row, false)"
              @confirm="handleCancel(scope.row, true)"
            >
              <el-switch
                v-model="scope.row.status"
                :active-value="1"
                :inactive-value="0"
                slot="reference"
                active-color="#13ce66"
                inactive-color="rgb(190, 190, 190)"
              />
            </el-popconfirm>
          </template>
        </el-table-column>
        <el-table-column label="操作" :width="150">
          <template v-slot="scope">
            <el-button
              class="no-margin center-children"
              type="text"
              size="small"
              @click="toEdit(scope.row)"
              >编辑</el-button
            >
            <el-popconfirm title="确定删除吗？" @confirm="toDel(scope.row)">
              <el-button
                slot="reference"
                class="no-margin center-children danger_btn_text"
                type="text"
                size="small"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div ref="pagination" class="pagination">
      <el-pagination
        :current-page="params.page"
        :page-size="params.size"
        :total="params.total"
        layout="total, prev, pager, next"
        @current-change="changePage"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    // 列表数据
    tableData: {
      type: Array,
      default: () => []
    },
    // 分页器数据
    params: {
      type: Object,
      default: () => {
        return {
          page: 1,
          size: 10,
          total: 0
        };
      }
    },
    // 是否加载中
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    changePage(page) {
      this.$emit("change-page", page);
    },
    formaterTime(row, column, cellValue, index) {
      const newTime = moment(cellValue).format("YYYY-MM-DD");
      return newTime;
    },
    // 启用/禁用
    handleCancel(row, mode) {
      if (!mode) {
        row.status = row.status === 1 ? 0 : 1;
      } else {
        let obj = {};
        obj = {
          id: row.id,
          status: row.status
        };
        this.$http({
          url: this.$api.deploy_status,
          data: obj
        }).then(res => {
          if (res.code == 0) {
            this.$message.success("启动成功");
            this.$emit("update");
          } else {
            row.status = row.status === 1 ? 0 : 1;
            this.$message.error(res.message);
          }
        });
      }
    },
    toEdit(row) {
      this.$emit("edit-data", row);
    },
    toDel(row) {
      this.$http({
        url: this.$api.deploy_del,
        method: "get",
        params: {
          id: row.id
        }
      })
        .then(res => {
          if (res.code == 0) {
            this.$message.success("删除日志成功");
            if (this.tableData.length === 1 && this.params.page !== 1) {
              this.$emit("change-page", this.params.page - 1);
            } else {
              this.$emit("update");
            }
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {
          this.$message.error("删除日志失败");
        });
    }
  }
};
</script>

<style lang="less" scoped>
.no-margin {
  margin: 0;
}
.center-children {
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.pagination {
  text-align: right;
}
.table_content {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px;
  .customer_list_table {
    flex: 1;
    height: 0;
  }
  .pagination {
    height: 32px;
  }
  .img_box {
    height: 100%;
    // display: flex;
    // align-items: center;
  }
  .logo {
    height: 100%;
    width: auto;
    // display: flex;
    // align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/views/UpdateJournal/Table.vue